/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".registration-page .p-steps{display:none}  .registration-page .stepbar{width:100%;margin-bottom:3rem;background-color:#b2bec3;transition:all 1s ease-in-out}  .registration-page .stepbar.hide{opacity:0}  .registration-page .stepbar .stepbar-progress{height:9px;background-color:#f6a91c;transition:all 1s ease-in-out}"];
export { styles as styles };
